import { emailRegex } from './emailRegex'

export const checkEmail = (email: string | undefined) => {
	const regex = emailRegex
	if (email === '' || !email) {
		alert('Kérlek add meg regisztrált e-mail címed')
		return false
	} else if (!regex.test(email)) {
		alert('A megadott e-mail cím nem valós.')
		return false
	} else return true
}

export const checkPassword = (password: string | undefined) => {
	if (password === '' || !password) {
		alert('Kérlek adj meg egy jelszót')
		return false
	} else return true
}

export const checkName = (name: string | undefined) => {
	if (name === '' || !name) {
		alert('A név nem lehet üres')
		return false
	} else return true
}
